import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import { Collapse, List, Tabs,ActionSheet, CalendarPickerView,Calendar, ImageUploader, Selection, Card, Form, Input, Space, Toast, Button } from 'antd-mobile'
import './index.less'
import moment from 'moment';
import { set } from 'lodash';

const defaultSingle = moment().format('YYYY-MM-DD');

//获取设备的具体保养信息
const PageModel = props => {
	const [info, setInfo] = useState('');
	const [time, setTime] = useState(defaultSingle);
	const [list, setList] = useState([]);
	const getData = async (id) => {
		if (!id) return;
		const result = await Request.get({
			url: `/equipmentInfo`,
			data: { id }
		});
		if (!result) return;
		setInfo(result.data);
	};

	const getList = async (data={}) => {
		data.time = data.time || time;
		const result = await Request.get({
			url: `/activityList`,
			data: data
		});
		if (!result) return;
		setList(result.data.list);
	}

	useEffect(() => {
		const { id } = props.match.params;
		if(id){
			getData(id);//id是设备的id
			getList({page:'0',id});//获取设备信号列表
		}
		
	}, [123]);
	return (
		<Page {...{ page: 'alleuipment', showFooter: false, title: '运行情况' }} {...props}>
			<section className="deatil-container">
				<div className='div_title'>
					<div className='div_title_left'>公司名称:</div>
					<div className='div_title_right'>{info && info.enterpriseName}</div>
				</div>
				<div className='div_title'>
					<div className='div_title_left'>店铺名称:</div>
					<div className='div_title_right'>{info && info.companyName}</div>
				</div>
				<div className='div_title'>
					<div className='div_title_left'>地址:</div>
					<div className='div_title_right'>{info && info.address}</div>
				</div>
				<div className='div_title'>
					<div className='div_title_left'>油烟净化器:</div>
					<div className='div_title_right'>
						{
							info && info.equipmentStaus == 0 && (
								<span className='green'>运行中</span>
							)
						}
						{
							info && info.equipmentStaus == 1 && (
								<span className='red'>烟雾报警</span>
							)
						}
						{
							info && info.equipmentStaus == 2 && (
								<span className='red'>断电停机中</span>
							)
						}
					</div>
				</div>
				<div className='div_title'>
					<div className='div_title_left'>净化器使用时间:</div>
					<div className='div_title_right'>{info && info.nextTime}h/{info && info.equipmentUpkeepTime}/h</div>
				</div>
				<div className='div_collapse'>
					<Collapse defaultActiveKey={['1']}>
						<Collapse.Panel key='1' title='日期选择'>
							<Calendar
								selectionMode='single'
								defaultValue={defaultSingle}
								onChange={val => {
									setList([]);
									setTime(moment(val).format('YYYY-MM-DD'))
									getList({ page: '0', id: props.match.params.id, time: moment(val).format('YYYY-MM-DD') });//获取设备信号列表
								}}
							/>
						</Collapse.Panel>
					</Collapse>
				</div>
				<div className='div_action_sheet'>
					<Tabs stretch={false} onChange={(val)=>{
						getList({ page: val, id: props.match.params.id });//获取设备信号列表
					}}>
						<Tabs.Tab title='正常' key='0'>
							{list.length>0 && list.map((item,index) => {
								return (
									<div key={index} className='div_imei'>
										<div className='div_left'>油烟净化器</div>
										<div className='div_middle'>{item.jh == 0 ? '正常' : '报警'}</div>
										<div className='div_right'>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</div>
									</div>
								)
							})}
							{list.length == 0 && <div className='div_imei'>暂无数据</div>}
						</Tabs.Tab>
						<Tabs.Tab title='报警' key='1'>
							{list.length > 0 && list.map((item, index) => {
								return (
									<div key={index} className='div_imei'>
										<div className='div_left'>油烟净化器</div>
										<div className='div_middle'>{item.jh == 0 ? '正常' : '报警'}</div>
										<div className='div_right'>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</div>
									</div>
								)
							})}
							{list.length == 0 && <div className='div_imei'>暂无数据</div>}
						</Tabs.Tab>
						<Tabs.Tab title='保养' key='2'>
							{list.length > 0 && list.map((item, index) => {
								return (
									<div key={index} className='div_imei'>
										{/* <div className='div_left'>油烟净化器</div> */}
										{/* <div className='div_middle'>{item.jh == 0 ? '正常' : '报警'}</div> */}
										<div className='div_right'>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</div>
									</div>
								)
							})}
							{list.length == 0 && <div className='div_imei'>暂无数据</div>}
						</Tabs.Tab>
						<Tabs.Tab title='维修' key='3'>
							{list.length > 0 && list.map((item, index) => {
								return (
									<div key={index} className='div_imei'>
										{/* <div className='div_left'>油烟净化器</div> */}
										{/* <div className='div_middle'>{item.jh == 0 ? '正常' : '报警'}</div> */}
										<div className='div_right'>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</div>
									</div>
								)
							})}
							{list.length == 0 && <div className='div_imei'>暂无数据</div>}
						</Tabs.Tab>
					</Tabs>
				</div>
					
			</section>
		</Page>
	);
};

export default PageModel;
